import { Stack, Typography } from '@mui/material';

export interface CardBodyProps {
  title: string;
  description: string;
}

const CardBody = ({ title, description }: CardBodyProps) => (
  <Stack spacing={1.5}>
    <Typography variant="h5" component="h2" sx={{ fontWeight: 800 }}>
      {title}
    </Typography>

    <Typography variant="subtitle1" color="text.secondary">
      {description}
    </Typography>
  </Stack>
);

export default CardBody;
